export const locale = {
    lang: 'es',
    data: {
        SAMPLE: {
            HELLO: 'Sección para presentar información gráfica sobre ordenes y operadores.'
        }
    }
};
